import { AccountData as CurrentAccountData } from "../../../../../account/domain/model/account.model";
import { SubmissionDetailsBaseComponentData, SubmissionDetailsHeaderData } from "../../submission-details.model";
import { Address, AppBarAction, EntityType, TimeInBusinessPeriod, AdvisorData } from "common";
import { FormGroup } from "@angular/forms";
import { RequirementData } from "../../shared/components/requirement-documents-section/requirement-documents-panel.model";
import { FormDetailsSectionHeaderConfig, FormDetailsSectionHeaderIconType } from "./shared/form-details-section-header/form-details-section-header.model";
import { SubmissionDetailsBannerData } from "../../shared/components/submission-details-banner-section/submission-details-banner-section.model";

export interface FormDetailsComponentData extends Partial<SubmissionDetailsBaseComponentData> {
  headerData: SubmissionDetailsHeaderData;
  advisorData: AdvisorData;
  appBarActions: AppBarAction[];
  formData?: SubmissionFormData;
  currentAccount?: CurrentAccountData;
  documentsData: DocumentsSectionData;
  bannerData?: SubmissionDetailsBannerData;
}

export enum FormDetailsActionType {
  SubmitForReview = "submitForReview",
}

export interface SubmissionFormData {
  businessInformation?: BusinessInformationFormData;
  ownersInformation?: OwnerInformationFormData[];
}

export interface SubmissionFormDiffData {
  businessDiffData?: BusinessInformationFormData;
  ownersDiffData?: OwnersDiffData;
}

export interface OwnersDiffData {
  addedOrUpdated: OwnerInformationFormData[];
  removed: OwnerInformationFormData[];
}

export interface BusinessInformationFormData {
  name?: string;
  ein?: string;
  entityType?: EntityType;
  phone?: string;
  address?: Address;
  dba?: string;
  timeInBusiness?: TimeInBusinessPeriod;
  description?: string;
  monthlySales?: number;
  requestedAmount?: number;
}

export interface OwnerInformationFormData {
  id?: number;
  tempUuid?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  mobilePhone?: string;
  address?: Address;
  birthdate?: Date | string;
  ssn?: string;
  createdOn?: Date;
}

export interface DocumentsSectionData {
  requirements: RequirementData[];
  hasAnyDocumentChanges: boolean;
  headerConfig: FormDetailsSectionHeaderConfig;
  headerIconType: FormDetailsSectionHeaderIconType;
  isValid: boolean;
}

export interface AutosaveQueueValidationStatus {
  hasAnySavableData: boolean;
  canClearPendingPayload?: boolean;
}

export interface AutosaveValidationData extends AutosaveQueueValidationStatus {
  isAutosaveBlocked: boolean;
  effectivePayload: SubmissionFormData;
  diffPayload: SubmissionFormDiffData
}

export interface AutosaveValidationInputData {
  submissionForm: FormGroup;
  lastSavedEffectivePayload: SubmissionFormData;
  pendingDiffPayload: SubmissionFormDiffData;
  processingDiffPayload: SubmissionFormDiffData;
  autosaveParams: AutosaveFormDetailsParams;
}

export interface AutosaveResponseData {
  params?: AutosaveFormDetailsParams;
  ownersStatus?: AutoSaveOwnersDetailsStatus;
}

export interface AutosaveFormDetailsParams {
  brokerId: number;
  accountId?: number;
  applicationId?: number;
}

export interface AutoSaveOwnersDetailsStatus {
  addedOrUpdated: OwnerInformationFormData[];
  removed: OwnerInformationFormData[];
}

export interface AutosaveTriggerData {
  status: AutosaveTriggerStatus;
  hasAnyChangesSaved: boolean;
}

export enum AutosaveTriggerStatus {
  NoSavableChanges = "noSavableChanges",
  Blocked = "blocked",
  Queuing = "queuing",
  Processing = "processing",
}

export interface UpdateDocumentsData {
  requirementChanges?: Partial<RequirementData>;
  hasAnyDocumentChanges?: boolean;
  canMarkInvalidSection?: boolean;
  isUploadDisabled?: boolean;
}
